import type { TeamId } from '../shared/index.js';

export const s = {
  name: '5 Saniye',
  pitch: 'Görev açılır, saat işler: 3 şey söyle, sonra arkadaşların karar versin',
  team: { a: 'Yeşil takım', b: 'Mor takım' } satisfies Record<TeamId, string>,
  settings: {
    readOnly: 'Ayarları oda sahibi seçer.',
    categories: 'Kategoriler',
    categoriesHint: '+18 kategoriler varsayılan olarak kapalıdır.',
    adultHint: '+18 kategoriler açık cinsel içerik içerir; yalnızca yetişkinler içindir.',
    coupleHint: 'Çift odası: partnerinle ikiniz için. Pas hakkı her zaman var; durmak isteyen durdurur.',
    mode: 'Oyun modu',
    solo: 'Herkes kendine',
    teams: 'İki takım',
    modeHint: 'Takım modunda puanlar takıma yazılır. Her takımda en az 2 kişi olmalı.',
    teamsTitle: 'Takımlar',
    teamsHint: 'Bir oyuncuya dokunarak takımını değiştir. Takımı seçilmeyenler başlarken dağıtılır.',
    unassigned: 'Takımsız',
    shuffle: 'Karıştır',
    shuffleLabel: 'Takımları karıştır',
    empty: 'Henüz kimse yok',
    needTwo: 'Her takımda en az 2 kişi olmalı.',
    seconds: 'Süre',
    sec: (n: number) => `${n} sn`,
    rounds: 'Oyuncu başına sıra',
    unlimited: 'Sınırsız',
    roundsHint: (n: number) => (n === 0 ? 'Oda sahibi bitirene kadar sürer.' : `Herkes ${n} kez görev alır.`),
    steal: 'Çalma kuralı',
    stealHint: 'Başaramayan oyuncunun görevini sıradaki oyuncu aynı sürede dener; başarırsa puanı o alır.',
    on: 'Açık',
    off: 'Kapalı',
    addPrompt: 'Görev ekle',
    addPromptHint: 'Eklediğin görev “Arkadaş görevleri” kategorisine girer ve kimseye listelenmez.',
    promptPlaceholder: '3 … söyle',
    promptLabel: 'Yeni görev',
    save: 'Görevi ekle',
    saving: 'Ekleniyor…',
    saved: 'Görev eklendi. Sırası gelince sürpriz olacak.',
    failed: 'Görev eklenemedi. Tekrar dene.',
  },
  play: {
    round: (n: number, total: number | null) => (total ? `Tur ${Math.min(n, total)}/${total}` : `Tur ${n}`),
    you: 'sen',
    youCap: 'Sen',
    phase: { ready: 'Hazırlık', mine: 'Sen söylüyorsun', speaking: (nick: string) => `${nick} söylüyor`, vote: 'Oylama' },
    secs: (n: number) => `${n} sn`,
    pip: (n: number) => `${n}. şey`,
    yourTurn: 'Sıra sende',
    next: 'Sırada',
    ready: 'Hazırım',
    readyHint: (sec: number) => `Basınca görev herkese açılır ve ${sec} saniye başlar. Yüksek sesle 3 şey söyle.`,
    readyFor: (nick: string) => `${nick} yerine başlat`,
    waiting: (nick: string) => `${nick} hazırlanıyor. Görev herkese aynı anda açılacak.`,
    stealTitle: 'Çalma şansı',
    stealBody: (from: string, to: string) => `${from} başaramadı. Aynı görev, aynı süre: ${to} puanı çalabilir.`,
    done: 'Söyledim',
    speak: (nick: string) => `${nick} söylüyor`,
    seconds: 'saniye',
    counter: 'Saydıkça dokun',
    counterLabel: (n: number) => `${n} şey sayıldı`,
    counterReset: 'Sayacı sıfırla',
    voteTitle: (nick: string) => `${nick} 3 şeyi söyleyebildi mi?`,
    voteYes: 'Başardı',
    voteNo: 'Başaramadı',
    voteWait: 'Arkadaşların karar veriyor.',
    voteCount: (n: number, total: number) => `${n}/${total} oy verildi`,
    voteHint: 'Eşitlikte başardı sayılır.',
    voteChange: 'Oyunu değiştirebilirsin.',
    swap: 'Görevi değiştir',
    skip: 'Sırayı atla',
    result: {
      success: (nick: string) => `${nick} başardı`,
      stolen: (nick: string) => `${nick} puanı çaldı`,
      fail: (nick: string) => `${nick} başaramadı`,
      skipped: (nick: string) => `${nick} atlandı`,
    },
    votes: (yes: number, no: number) => `${yes} evet, ${no} hayır`,
    points: 'puan',
    scoreboard: 'Skorlar',
    scoreboardRound: (round: string) => `Skorlar · ${round}`,
    offline: 'bağlantı yok',
  },
  podium: {
    title: 'En hızlı ağızlar',
    gameOver: 'Oyun bitti',
    winnerTeam: (team: string) => `${team} kazandı!`,
    winner: (nick: string) => `${nick} kazandı!`,
    draw: 'Berabere',
    back: 'Lobiye dönülüyor…',
    place: (n: number) => `${n}.`,
  },
  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Hazırım', 'Sıra sana gelince “Hazırım”a bas. Görev herkesin ekranında aynı anda açılır.'],
      ['3 şey söyle', 'Süre bitmeden görevdeki 3 şeyi yüksek sesle söyle. Takılmak serbest, susmak yasak.'],
      ['Oylama', 'Süre bitince diğerleri “Başardı” ya da “Başaramadı” der. Çoğunluk kazanır, eşitlikte başardı sayılır.'],
      ['Puan', 'Başarırsan +1 puan. Çalma kuralı açıksa başaramadığın görevi sıradaki oyuncu deneyip puanı alabilir.'],
    ] as [string, string][],
  },
};
